const Routes = {
    error: '/error',
    holder_list: '/holders',
    holder_profile: '/holders/:id',
    intake: '/intake',
    login: '/login',
    logout: '/logout',
    photo: '/intake/photo/upload',
    referrals: '/referrals',
    root: '/',
    settings: '/settings',
    support: '',
    wiki: process.env.REACT_APP_WIKI_URL || 'https://kb.samaritan.city/partner',
    quick_link: '/l/:type', // Base quick link route
};

export default Routes;
